import { render, staticRenderFns } from "./UsuarioexpedienteQuicktable.vue?vue&type=template&id=73c3231c&"
import script from "./UsuarioexpedienteQuicktable.vue?vue&type=script&lang=js&"
export * from "./UsuarioexpedienteQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports